var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  Adapter library for working with pubsub channels and messages
*/
// Local libraries
var Messaging = require('./messaging');

var AboutAdapter = require('./about-adapter');

var PubsubAdapter = /*#__PURE__*/function () {
  "use strict";

  function PubsubAdapter() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PubsubAdapter);

    // Dependency Injection
    this.ipfs = localConfig.ipfs;

    if (!this.ipfs) {
      throw new Error('Instance of IPFS adapter required when instantiating Pubsub Adapter.');
    }

    this.log = localConfig.log;

    if (!this.log) {
      throw new Error('A status log handler function required when instantitating Pubsub Adapter');
    }

    this.encryption = localConfig.encryption;

    if (!this.encryption) {
      throw new Error('An instance of the encryption Adapter must be passed when instantiating the Pubsub Adapter library.');
    }

    this.privateLog = localConfig.privateLog;

    if (!this.privateLog) {
      throw new Error('A private log handler must be passed when instantiating the Pubsub Adapter library.');
    } // Encapsulate dependencies


    this.messaging = new Messaging(localConfig);
    this.about = new AboutAdapter(localConfig); // 'embedded' node type used as default, will use embedded js-ipfs.
    // Alternative is 'external' which will use ipfs-http-client to control an
    // external IPFS node.

    this.nodeType = localConfig.nodeType;

    if (!this.nodeType) {
      // console.log('No node type specified. Assuming embedded js-ipfs.')
      this.nodeType = 'embedded';
    } // console.log(`PubsubAdapter contructor node type: ${this.nodeType}`)

  } // Subscribe to a pubsub channel. Any data received on that channel is passed
  // to the handler.


  _createClass(PubsubAdapter, [{
    key: "subscribeToPubsubChannel",
    value: function () {
      var _subscribeToPubsubChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(chanName, handler, thisNode) {
        var _this = this;

        var thisNodeId;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                // console.log('thisNode: ', thisNode)
                thisNodeId = thisNode.ipfsId; // Normal use-case, where the pubsub channel is NOT the receiving channel
                // for this node. This applies to general broadcast channels like
                // the coordination channel that all nodes use to annouce themselves.

                if (!(chanName !== thisNodeId)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 5;
                return this.ipfs.ipfs.pubsub.subscribe(chanName, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(msg) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.parsePubsubMessage(msg, handler, thisNode);

                          case 2:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.next = 9;
                return this.ipfs.ipfs.pubsub.subscribe(chanName, /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(msg) {
                    var msgObj;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _this.messaging.handleIncomingData(msg, thisNode);

                          case 2:
                            msgObj = _context2.sent;

                            if (!msgObj) {
                              _context2.next = 6;
                              break;
                            }

                            _context2.next = 6;
                            return _this.handleNewMessage(msgObj, thisNode);

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 9:
                this.log.statusLog(0, "status: Subscribed to pubsub channel: ".concat(chanName));
                return _context3.abrupt("return", true);

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](0);
                console.error('Error in subscribeToPubsubChannel()');
                throw _context3.t0;

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 13]]);
      }));

      function subscribeToPubsubChannel(_x, _x2, _x3) {
        return _subscribeToPubsubChannel.apply(this, arguments);
      }

      return subscribeToPubsubChannel;
    }() // After the messaging.js library does the lower-level message handling and
    // decryption, it passes the message on to this function, which does any
    // additional parsing needed, and
    // then routes the parsed data on to the user-specified handler.

  }, {
    key: "handleNewMessage",
    value: function () {
      var _handleNewMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(msgObj, thisNode) {
        var isAbout;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.captureMetrics(msgObj.data.payload, msgObj.from, thisNode);

              case 3:
                isAbout = _context4.sent;

                if (isAbout) {
                  _context4.next = 7;
                  break;
                }

                // console.log('handleNewMessage() forwarding payload on to handler.')
                this.privateLog(msgObj.data.payload, msgObj.from);
                return _context4.abrupt("return", true);

              case 7:
                return _context4.abrupt("return", false);

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                console.error('Error in handleNewMessage()');
                throw _context4.t0;

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function handleNewMessage(_x6, _x7) {
        return _handleNewMessage.apply(this, arguments);
      }

      return handleNewMessage;
    }() // Scans input data. If the data is determined to be an 'about' JSON RPC
    // reponse used for metrics, then the relayMetrics event is triggered and
    // true is returned. Otherwise, false is returned.

  }, {
    key: "captureMetrics",
    value: function () {
      var _captureMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(decryptedStr, from, thisNode) {
        var data, jsonResponse, peerData, payload;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                // console.log('decryptedStr: ', decryptedStr)
                // console.log('thisNode: ', thisNode)
                data = JSON.parse(decryptedStr); // console.log('data: ', data)
                // Handle /about JSON RPC queries.

                if (!(data.id.includes('metrics') && data.method === 'about')) {
                  _context5.next = 13;
                  break;
                }

                // Request recieved, send response.
                // console.log('/about JSON RPC captured. Sending back announce object.')
                // console.log('thisNode.schema.state.announceJsonLd: ', thisNode.schema.state.announceJsonLd)
                jsonResponse = "{\"jsonrpc\": \"2.0\", \"id\": \"".concat(data.id, "\", \"result\": {\"method\": \"about\", \"receiver\": \"").concat(from, "\", \"value\": ").concat(JSON.stringify(thisNode.schema.state), "}}"); // console.log(`Responding with this JSON RPC response: ${jsonResponse}`)
                // Encrypt the string with the peers public key.

                peerData = thisNode.peerData.filter(function (x) {
                  return x.from === from;
                });
                _context5.next = 7;
                return this.encryption.encryptMsg(peerData[0], jsonResponse);

              case 7:
                payload = _context5.sent;
                _context5.next = 10;
                return this.messaging.sendMsg(from, payload, thisNode);

              case 10:
                return _context5.abrupt("return", true);

              case 13:
                if (!(data.id.includes('metrics') && data.result && data.result.method === 'about')) {
                  _context5.next = 16;
                  break;
                }

                // Response received.
                // console.log('JSON RPC /about response aquired.')
                // This event is handled by the about-adapter.js. It measures the
                // latency between peers.
                this.about.relayMetricsReceived(decryptedStr);
                return _context5.abrupt("return", data.result.value);

              case 16:
                return _context5.abrupt("return", false);

              case 19:
                _context5.prev = 19;
                _context5.t0 = _context5["catch"](0);
                console.error('Error in captureMetrics: ', _context5.t0);
                return _context5.abrupt("return", false);

              case 23:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 19]]);
      }));

      function captureMetrics(_x8, _x9, _x10) {
        return _captureMetrics.apply(this, arguments);
      }

      return captureMetrics;
    }() // Attempts to parse data coming in from a pubsub channel. It is assumed that
    // the data is a string in JSON format. If it isn't, parsing will throw an
    // error and the message will be ignored.

  }, {
    key: "parsePubsubMessage",
    value: function () {
      var _parsePubsubMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(msg, handler, thisNode) {
        var thisNodeId, from, channel, data, retObj;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                // console.log('message data: ', msg.data)
                // console.log('parsePubsubMessage msg: ', msg)
                // console.log('thisNode: ', thisNode)
                thisNodeId = thisNode.ipfsId; // Get data about the message.

                from = msg.from;
                channel = msg.topicIDs[0]; // Used for debugging.

                this.log.statusLog(2, "Broadcast pubsub message recieved from ".concat(from, " on channel ").concat(channel)); // Ignore this message if it originated from this IPFS node.

                if (!(from === thisNodeId)) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", true);

              case 7:
                // The data on browsers comes through as a uint8array, and on node.js
                // implementiong it comes through as a string. Browsers need to
                // convert the message from a uint8array to a string.
                // console.log('this.nodeType: ', this.nodeType)
                if (thisNode.type === 'browser' || this.nodeType === 'external') {
                  // console.log('Node type is browser')
                  msg.data = new TextDecoder('utf-8').decode(msg.data);
                } // Parse the data into a JSON object. It starts as a Buffer that needs
                // to be converted to a string, then parsed to a JSON object.
                // For some reason I have to JSON parse it twice. Not sure why.


                data = JSON.parse(JSON.parse(msg.data.toString())); // console.log('data: ', data)

                retObj = {
                  from: from,
                  channel: channel,
                  data: data
                }; // console.log(`new pubsub message received: ${JSON.stringify(retObj, null, 2)}`)
                // Hand retObj to the callback.

                handler(retObj);
                return _context6.abrupt("return", true);

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](0);
                console.error('Error in parsePubsubMessage(): ', _context6.t0.message); // Do not throw an error. This is a top-level function.

                return _context6.abrupt("return", false);

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 14]]);
      }));

      function parsePubsubMessage(_x11, _x12, _x13) {
        return _parsePubsubMessage.apply(this, arguments);
      }

      return parsePubsubMessage;
    }()
  }]);

  return PubsubAdapter;
}();

module.exports = PubsubAdapter;